import { Button } from '#/components/Button/Button';
import { Hide } from '#/components/Hide/Hide';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { OrgDashboardApiOrg } from '#/modules/orgDashboard/api/types/OrgDashboardApiOrg';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

type Props = {
  org: OrgDashboardApiOrg;
  isPublished?: boolean;
  editMode: boolean;
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  setEditMode: (...args: any[]) => any;
};

export function ActionButtons({
  org,
  isPublished,
  editMode,
  setEditMode,
}: Props) {
  const { i18n } = useI18n();

  const editUrl = `/admin/${org.id}/edit`;

  const toggleEditMode = () => {
    trackClicked(`Org Profile: Admin ${editMode ? 'Preview' : 'Edit'} Mode`);
    setEditMode(!editMode);
  };

  return (
    <>
      {org.isFrozen && (
        <Button
          type="link"
          href="https://www.idealist.org/en/about/contact"
          size="small"
          variant="secondary-white"
        >
          {i18n('Contact')}
        </Button>
      )}
      <Button
        type="link"
        href={editUrl}
        qaId="edit-button"
        size="small"
        variant="secondary-white"
        onClick={() => {
          if (!org.isFrozen && !isPublished) {
            trackClicked('Org Preview - Edit Org Profile');
          }
        }}
      >
        {i18n('Edit')}
      </Button>
      <Button
        type="button"
        size="small"
        onClick={toggleEditMode}
        qaId="preview-button"
        variant="secondary-white"
      >
        {/* TODO: Fix this the next time the file is edited. */}
        {/* oxlint-disable-next-line no-nested-ternary */}
        {!editMode ? (
          i18n('View Edit Mode')
        ) : isPublished ? (
          <>
            <Hide sm md lg xl>
              {i18n('Preview')}
            </Hide>
            <Hide xs>{i18n('View Public Profile')}</Hide>
          </>
        ) : (
          i18n('Preview')
        )}
      </Button>
      {!org.isFrozen && (org.is501c3 || isPublished) && (
        <Button
          type="link"
          size="small"
          variant="secondary-white"
          href={`/admin/${org.id}/jobs/create`}
          onClick={() => {
            if (isPublished) {
              trackClicked('Org Profile - Post a Job');
            } else {
              trackClicked('Org Preview - Post a Job');
            }
          }}
        >
          {i18n('Post a Job')}
        </Button>
      )}
    </>
  );
}
